<template>
  <div class="loading-overlay-container">
    <BallSpinFadeLoader
      color="#3AB982"
      margin="2px"
      size="10px"
      radius="2px"
    />
  </div>
</template>

<style lang="scss">
  .loading-overlay-container{
    background-color: rgba(255, 255, 255, 0.8);
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 999;
    //opacity: 0.2;
    margin: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: opacity .3s;

    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

</style>

<script>
  export default {
    name: "BaseLoadingOverlay"
  }
</script>



// WEBPACK FOOTER //
// src/components/Base/BaseLoadingOverlay.vue